import { render } from "./Picture.vue?vue&type=template&id=2b9b0c2d&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"

import "./Picture.vue?vue&type=style&index=0&id=2b9b0c2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b0c2d"]])

export default __exports__